<template>
  <v-container fluid class="pa-0 py-2">
    <v-row no-gutters>
      <v-col v-if="!isFromMe" cols="auto" class="pl-3 pr-3 d-flex flex-column justify-end">
        <UserChip :user="item.User" :index="0" :typecolored="true" :onlyavatar="true">
        </UserChip>
        <!-- <v-card dark color="red" class="rounded-circle px-1">AB</v-card> -->
      </v-col>
      <v-col cols="0" :class="isFromMe ? 'pl-13 d-flex justify-end' : 'd-flex justify-start'" class="pr-5">
        <v-card width="fit-content" :dark="isFromMe" :color="isFromMe ? 'primary' : ''" class="pa-2">
          {{ item.Comment }}
        </v-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col :class="isFromMe ? 'pl-14 text-end' : 'pl-3'" class="pr-5">
        <small>
          {{ isFromMe ? 'You - ' : (item.UserDisplayName ? (item.UserDisplayName + ' - ') : '') }}{{ i18nFormatDateTime(item.TimerDate) }}
        </small>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import UserChip from "@/components/Buttons/UserChip.vue";

export default {
  name: "LoggListItem",
  props: ["item"],
  components: {
    UserChip,
  },

  data() {
    return {
      startWorkKey: "Start Work",
      stopWorkKey: "Stop Work",
      startDriveKey: "Start Drive",
      stopDriveKey: "Stop Drive",
    };
  },

  mounted() { },

  methods: {
    select() {
      this.$emit("fetch", this.item);
    },
  },

  computed: {    

    isFromMe() {
      return this.item.User.Id == this.userInfo.Id;
    },

    userInfo() {
      return this.$store.getters["userInfo"];
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped>
/*
.eventline::before,
.eventline::after {
  content: "";
  position: absolute;
  border-radius: 3px;
  width: 3px;
  left: 24px;
  height: 10px;
  z-index: 0;
  background-color: rgb(221, 221, 221);
}
.eventline::before {
  top: -3px;
}
.eventline::after {
  bottom: -3px;
}
*/
</style>